import { AnalyticsEvent } from "./enums/analytics-event.enum";
import { QuizEvent } from "./enums/quiz-event.enum";
import { PostMessageService, postMessageService } from './services/post-message.service';

export class AnalyticsService {
  constructor(private readonly postMessageService: PostMessageService) { }

  send(event: AnalyticsEvent, params?: Record<string, any>) {
    this.postMessageService.send({ event: QuizEvent.REACH_GOAL, data: { event, params } });
    this.postMessageService.send({ event: QuizEvent.SEND_ANALYTICS, data: { event, params } });
  }

  sendParams(params: Record<string, any>) {
    this.postMessageService.send({ event: QuizEvent.SET_ANALYTICS_PARAMS, data: { event: QuizEvent.SET_ANALYTICS_PARAMS, params } });
  }
}

export const analyticsService = new AnalyticsService(postMessageService);